import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';
type HeaderContentProps = React.HTMLAttributes<HTMLDivElement> & {
  hasContent?: boolean;
};
const HeaderContent = forwardRef<HTMLDivElement, HeaderContentProps>((t0, ref) => {
  const $ = _c(13);
  let children;
  let hasContent;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      hasContent,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = hasContent;
    $[3] = props;
  } else {
    children = $[1];
    hasContent = $[2];
    props = $[3];
  }
  const t1 = hasContent || undefined;
  const t2 = !hasContent;
  let t3;
  if ($[4] !== hasContent || $[5] !== t2) {
    t3 = cx("relative flex justify-center items-center", {
      "h-[var(--navigation-header-height)] py-4 md:py-3": hasContent,
      "py-2 md:py-1.5": t2
    });
    $[4] = hasContent;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children || $[8] !== props || $[9] !== ref || $[10] !== t1 || $[11] !== t3) {
    t4 = <div ref={ref} data-has-content={t1} className={t3} {...props}>{children}</div>;
    $[7] = children;
    $[8] = props;
    $[9] = ref;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
});
export default HeaderContent;